import __request__ from "routing/request";
export function set(JSONbody) {
  return __request__("POST", "/favorite_fields", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function add(JSONbody) {
  return __request__("PATCH", "/favorite_fields/add", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(JSONbody) {
  return __request__("PATCH", "/favorite_fields/remove", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
